"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptItem = void 0;
/* eslint-disable no-constant-condition */
const react_1 = __importStar(require("react"));
const Spinner_1 = __importDefault(require("react-bootstrap/Spinner"));
const standard_1 = require("react-hook-schema/standard");
const react_bootstrap_1 = require("react-bootstrap");
const models_hook_1 = require("app/models.hook");
const components_1 = require("utils/components");
const auth_1 = require("common/auth");
const components_2 = require("utils/components");
const ScriptItemForm_1 = __importDefault(require("./ScriptItemForm"));
const ScriptItem = ({ langId, projectId, segmentId, onAction, readOnly, scriptDoc, splitMode, isLastElement, }) => {
    const accessorRef = react_1.default.useRef(null);
    const { data, loading } = scriptDoc;
    const confirm = (0, standard_1.useConfirm)();
    const dataKey = (0, react_1.useMemo)(() => {
        return {
            textKey: data.text,
            translationsKey: JSON.stringify(data.translations),
        };
    }, [data.text, data.translations]);
    const { list: comments, upsert: upsertComment, remove: removeComment, } = (0, models_hook_1.useCommentList)({
        projectId,
        segmentId,
        scriptId: data.scriptId,
    });
    const numberOfUnresolvedComment = (0, react_1.useMemo)(() => {
        var _a;
        return ((_a = comments === null || comments === void 0 ? void 0 : comments.filter((comment) => comment.scriptId === data.scriptId && !(comment === null || comment === void 0 ? void 0 : comment.resolved))) !== null && _a !== void 0 ? _a : []).length;
    }, [comments, data.scriptId]);
    const { loading: loadingAdmin, user } = (0, auth_1.useAdminAuthentication)();
    const { list } = (0, models_hook_1.useAuthEmailList)({});
    const sortedComments = (0, react_1.useMemo)(() => {
        const copied = [...(comments !== null && comments !== void 0 ? comments : [])];
        copied.sort((a, b) => b.createdAt - a.createdAt);
        return copied;
    }, [comments]);
    const [showResolvedComments, setShowResolvedComments] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: "script-item", style: { position: "relative" } }, loading ? (react_1.default.createElement("div", { style: {
                padding: "20px",
                position: "absolute",
                top: "0",
                left: "0",
                zIndex: 1,
            } },
            react_1.default.createElement(Spinner_1.default, { animation: "border", role: "status" },
                react_1.default.createElement("span", { className: "visually-hidden" }, "Loading...")))) : (react_1.default.createElement(ScriptItemForm_1.default, { splitMode: splitMode, projectId: projectId, segmentId: segmentId, langId: langId, data: data, readOnly: readOnly, accessorRef: accessorRef, updateRef: dataKey, numberOfUnresolvedComment: numberOfUnresolvedComment, onAction: onAction, isLastElement: isLastElement }))),
        react_1.default.createElement(components_1.SidePanel, { title: react_1.default.createElement("i", { className: "mdi mdi-comment-multiple-outline", "data-tooltip-id": "tooltip", "data-tooltip-content": "\u30B3\u30E1\u30F3\u30C8" }), kind: "comments", priority: 5 },
            react_1.default.createElement("section", { className: "sidePanelTitle" }, "\u30B3\u30E1\u30F3\u30C8"),
            !loadingAdmin && user && (react_1.default.createElement(CommentItemForm, { key: JSON.stringify({
                    projectId,
                    segmentId,
                    scriptId: data.scriptId,
                }), parameter: {
                    edit: {
                        handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                            yield (upsertComment === null || upsertComment === void 0 ? void 0 : upsertComment({
                                projectId,
                                segmentId,
                                scriptId: data.scriptId,
                                comment: [{ type: "text", content: values.content }],
                                creatorEmail: user.email,
                            }));
                        }),
                    },
                } })),
            react_1.default.createElement("div", { className: "form-check form-switch", style: { margin: "10px" } },
                react_1.default.createElement("input", { className: "form-check-input", type: "checkbox", role: "switch", checked: showResolvedComments, onChange: () => setShowResolvedComments((c) => !c) }),
                react_1.default.createElement("label", { className: "form-check-label" }, "\u89E3\u6C7A\u6E08\u30B3\u30E1\u30F3\u30C8\u3092\u518D\u8868\u793A")),
            react_1.default.createElement("ul", null, sortedComments.map((comment) => {
                var _a, _b;
                if (!showResolvedComments && comment.resolved)
                    return react_1.default.createElement(react_1.Fragment, { key: comment.commentId });
                return (react_1.default.createElement("li", { key: comment.commentId, className: "border-bottom", style: { padding: 12 } },
                    react_1.default.createElement("div", { style: { display: "flex", gap: "8px" } },
                        comment.resolved ? (react_1.default.createElement("i", { "data-tooltip-id": "tooltip", "data-tooltip-content": "解決済・クリックして未解決にする", className: "mdi mdi-circle text-primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                yield (upsertComment === null || upsertComment === void 0 ? void 0 : upsertComment(Object.assign(Object.assign({}, comment), { resolved: false })));
                            }), style: {
                                fontSize: "2em",
                                cursor: "pointer",
                                lineHeight: "0.8em",
                                flexShrink: 0,
                            } })) : (react_1.default.createElement("i", { "data-tooltip-id": "tooltip", "data-tooltip-content": "未解決・クリックして解決済にする", className: "mdi mdi-circle-outline text-primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                yield (upsertComment === null || upsertComment === void 0 ? void 0 : upsertComment(Object.assign(Object.assign({}, comment), { resolved: true })));
                            }), style: {
                                fontSize: "2em",
                                cursor: "pointer",
                                lineHeight: "0.8em",
                                flexShrink: 0,
                            } })),
                        comment.comment.map((c, i) => (react_1.default.createElement("span", { key: i, style: { wordBreak: "break-word" } }, c.content)))),
                    react_1.default.createElement("div", { style: { textAlign: "right", fontSize: "0.8em" } },
                        "by",
                        " ", (_b = (_a = list === null || list === void 0 ? void 0 : list.find((u) => u.email === comment.creatorEmail)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : comment.creatorEmail,
                        " ",
                        "/ at ",
                        new Date(comment.createdAt).toLocaleString(),
                        react_1.default.createElement("i", { "data-tooltip-id": "tooltip", "data-tooltip-content": "削除", className: "mdi mdi-trash-can-outline text-primary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                                if (!(yield confirm({
                                    message: "コメントを削除しますか？",
                                })))
                                    return;
                                yield (removeComment === null || removeComment === void 0 ? void 0 : removeComment(comment));
                            }), style: {
                                fontSize: "1.4em",
                                marginLeft: "0px",
                                cursor: "pointer",
                                visibility: comment.creatorEmail === (user === null || user === void 0 ? void 0 : user.email)
                                    ? "visible"
                                    : "hidden",
                            } }))));
            })))));
};
exports.ScriptItem = ScriptItem;
const CommentItemForm = ({ parameter }) => {
    const { edit } = parameter;
    const [text, setText] = (0, react_1.useState)("");
    const clickSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            if (!text)
                return;
            yield ((_a = edit === null || edit === void 0 ? void 0 : edit.handler) === null || _a === void 0 ? void 0 : _a.call(edit, {
                content: text,
            }));
            setText("");
        }
        catch (e) {
            console.error(e);
        }
    });
    return (react_1.default.createElement("div", { className: "tile", style: { margin: "5px" } },
        react_1.default.createElement(react_bootstrap_1.InputGroup, null,
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", as: "textarea", placeholder: "\u30B3\u30E1\u30F3\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", value: text, onChange: (e) => setText(e.target.value) }),
            react_1.default.createElement(components_2.Button, { onClick: clickSubmit, variant: text ? "primary" : "secondary", disabled: !text },
                react_1.default.createElement("i", { className: "mdi mdi-send" })))));
};
